import { create } from "zustand";

const defaultEditOrderSteps = [
    {
        id: "edit-order",
        title: "Edit order",
        description: "",
        isPrepared: false,
    },
];

const defaultViewOrderSteps = [
    {
        id: "view-order",
        title: "View order",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: true,
    },
];

const defaultLinkOrderSteps = [
    {
        id: "link-order",
        title: "Link order to contract",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
    },
];
const defaultAddOutcomeSteps = [
    {
        id: "add-outcome",
        title: "Add outcome",
        description:
            "Lorem 1 ipsum dolor sit amet, consectetur adipiscing elit. Nunc sed risus ut elit nibh id. Nisl, praesent pulvinar.",
        isPrepared: false,
    },
];

interface OrderState {
    linkOrderSteps: typeof defaultLinkOrderSteps;
    setLinkOrderSteps: (steps: any) => void;

    editOrderSteps: typeof defaultEditOrderSteps;
    setEditOrderSteps: (steps: any) => void;

    viewOrderSteps: typeof defaultViewOrderSteps;
    setViewOrderSteps: (steps: any) => void;

    addOutcomeSteps: typeof defaultAddOutcomeSteps;
    setAddOutcomeSteps: (steps: any) => void;

    resetOrderData: () => void;
}

export const useOrderStore = create<OrderState>(set => ({
    linkOrderSteps: defaultLinkOrderSteps,
    setLinkOrderSteps: linkOrderSteps => set({ linkOrderSteps }),

    editOrderSteps: defaultEditOrderSteps,
    setEditOrderSteps: editOrderSteps => set({ editOrderSteps }),

    viewOrderSteps: defaultViewOrderSteps,
    setViewOrderSteps: viewOrderSteps => set({ viewOrderSteps }),

    addOutcomeSteps: defaultAddOutcomeSteps,
    setAddOutcomeSteps: addOutcomeSteps => set({ addOutcomeSteps }),
    resetOrderData: () =>
        set({
            linkOrderSteps: defaultLinkOrderSteps,
            editOrderSteps: defaultEditOrderSteps,
            viewOrderSteps: defaultViewOrderSteps,
            addOutcomeSteps: defaultAddOutcomeSteps,
        }),
}));
